export class SystemaktivitetTexts {
// eslint-disable-next-line sonarjs/public-static-readonly
    static texts = {
        addSystemaktivitet: "Lägg till systemaktivitet",
        editSystemaktivitet: "Redigera systemaktivitet",
        saveSystemaktivitetOk: "Systemaktiviteten har sparats",
        deleteSystemaktivitetConfirmed: "Systemaktiviteten har tagits bort",
        deleteSystemaktivitetDialogHead: "Ta bort systemaktivitet",
        deleteSystemaktivitetDialogPromt: "Vill du verkligen ta bort systemaktiviteten?"
    };
}
